export default "__VITE_ASSET__c89d43e5__"